export const manifest = {
  screens: {
    scr_mlzihl: { name: "Home", route: "/" },
  },
}
